import React, { useRef } from 'react';

// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import Cookies from 'js-cookie';
import SectionsInfo from '../SectionsInfo';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import PartnerCard from './PartnerCard';
import useWindowSize from '../../hooks/useWindowSize';

function OurPartners({ data }) {
  const { width } = useWindowSize();
  const lang = Cookies.get('i18next') || 'en';
  const swiperRef = useRef(null);
  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };
  return (
    <div className="out__partners">
      <div className="partners_bg_circle" />
      <div className="container medium">
        <SectionsInfo
          handleNext={handleNext}
          handlePrev={handlePrev}
          isPartner
          isSlider
          title={data.title[lang]}
          description={data.content_title[lang]}
        />
        <Swiper
          loop
              // eslint-disable-next-line no-return-assign
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className="our__team-slider"
          style={{ marginTop: width > 768 ? 60 : 24 }}
          spaceBetween={width > 768 ? 24 : 16}
          slidesPerView={width > 768 ? 6 : 2.4}
        >
          {data.data.map((e) => (
            <SwiperSlide key={e.id}>
              <PartnerCard
                name={e.title ? e.title[lang] : 'partner'}
                link={e.url}
                image={e?.image?.webp_url}
                imageAlt={e.image ? e?.image?.alt_attribute[lang] : ''}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default OurPartners;
